import React from 'react';
import { isTestEnvironment } from '../utils/envDetection';

/**
 * TestEnvBadge — vaste badge die ALLEEN op test.testwisely.nl verschijnt,
 * zodat je altijd ziet dat je in de testomgeving zit. Op productie rendert 'ie niets.
 *
 * Bovenaan in het midden, pointer-events:none (blokkeert nooit een klik),
 * hoogste z-index. Stond linksonder, maar viel daar over de naam en rol van
 * de gebruiker in de zijbalk (13-10-2026).
 */
export default function TestEnvBadge() {
  if (!isTestEnvironment()) return null;
  return (
    <div
      aria-hidden="true"
      style={{
        position: 'fixed',
        top: 6,
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: 2147483647,
        pointerEvents: 'none',
        background: '#f59e0b',
        color: '#1e293b',
        fontSize: 11,
        fontWeight: 800,
        letterSpacing: '0.06em',
        textTransform: 'uppercase',
        padding: '3px 10px',
        borderRadius: 999,
        boxShadow: '0 2px 10px rgba(0,0,0,0.25)',
        fontFamily: 'system-ui, -apple-system, sans-serif',
        userSelect: 'none',
      }}
    >
      Testomgeving
    </div>
  );
}
